'use client';

/**
 * Provides session to @korvo/core via SessionContext using the auth library's
 * useSession() (industry standard). Session is also available via useSession()
 * from @/lib/better-auth/client elsewhere in the app.
 */

import { SessionContext } from '@korvo/core/client/contexts/SessionContext';

import { useSession } from '@/lib/better-auth/client';

export function AppSessionProvider({ children }: { children: React.ReactNode }) {
  const sessionState = useSession();

  return (
    <SessionContext.Provider value={sessionState}>
      {children}
    </SessionContext.Provider>
  );
}
